export default __webpack_public_path__ + "1180ff3d97cb2f4fd0fd8c3fd47af47c.svg";